/**
 * Standard error response format for API errors
 */
export interface ErrorResponse {
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
}

/**
 * Error codes used across the application
 */
export enum ErrorCode {
  // Validation and Input Errors
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_STATUS_TRANSITION = 'INVALID_STATUS_TRANSITION',
  INVALID_ROLE_ASSIGNMENT = 'INVALID_ROLE_ASSIGNMENT',
  
  // Resource Errors
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
  GONE = 'GONE',
  
  // Authentication and Authorization
  UNAUTHORIZED = 'UNAUTHORIZED',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  RATE_LIMITED = 'RATE_LIMITED',
  
  // External Service Errors
  EMAIL_ERROR = 'EMAIL_ERROR',
  EMAIL_SEND_FAILED = 'EMAIL_SEND_FAILED',
  
  // System Errors
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  HTTP_ERROR = 'HTTP_ERROR',
  PACKET_ERROR = 'PACKET_ERROR'
} 